<template>
  <fragment>
    <div>
      <!--   QUESTION SECTION   -->
      <b-col class="text-left v2_study_question_section" cols="12" style="background-color: #F7FAFA">
        <!--  preamble  -->
        <div
          class="preamble v2_font_style_italic v2_font_size_20 v3_color_black_knight"
          v-if="question.preamble"
          v-html="preamble"
        />
        <!--prompt-->
        <div
          class="prompt font_size_1500rem font-weight-bold"
          v-html="prompt"
        />

        <!--explanation-->
        <div
          class="font_size_1000rem my-3"
          v-if="question.explanation"
          v-html="explanation"
        />

        <div v-if="question.type === 'YES_NO'">
          <b-form-radio-group
            v-if="!questionVariables[0].delete_me"
            class="text-left v3_control_radio_group"
            :disabled="disabled"
            v-model="preview ? {} : questionVariables[0].response.value"
            @change="resetDeclinedAndAutosave()"
          >
            <b-form-radio :value="'1'" class="col-12 my-2">
              Yes
            </b-form-radio>
            <b-form-radio :value="'0'" class="col-12 my-2">
              No
            </b-form-radio>
          </b-form-radio-group>
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'FIND_STATE'">
          <!-- if we have a single input, scooch it down a bit if the question has a preamble -->
          <div v-if="question.preamble" class="my-4" />
          <b-form-select
            :disabled="disabled"
            v-model="preview ? {} : questionVariables[0].response.value"
            @change="resetDeclinedAndAutosave()"
            :options="getStateOptions()"
            class="mb-3"
          />
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'FIND_REGION'">
          <!-- if we have a single input, scooch it down a bit if the question has a preamble -->
          <div v-if="question.preamble" class="my-4" />
          <b-form-select
            :disabled="disabled"
            v-model="preview ? {} : questionVariables[0].response.value"
            @change="resetDeclinedAndAutosave()"
            :options="getRegionOptions()"
            class="mb-3"
          />
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'FIND_SCHOOL'">
          <vue-bootstrap-typeahead
            :disabled="disabled"
            v-model="initialSchool"
            @change="resetDeclinedAndAutosave()"
            placeholder="Type name of school..."
            :data="getSchoolOptions()"
          />
        </div>
        <!-- --------------------- -->

        <div v-else-if="question.type === 'CONFIRMATION'">
          <div class="row" v-for="v in visibleQuestionVariables" :key="v.id">
            <div class="col">
              <label class="font-weight-bold">{{ v.input_label }}</label>
            </div>
            <div class="col">
              <div class="question-form__derived-variable-value">
                {{ formatDerivedVariableResponseValue(v) }}
              </div>
            </div>
          </div>
        </div>

        <!-- --------------------- -->

        <div
          v-else-if="visibleQuestionVariables.length === 0 && conditionQuestion"
        >
          <p class="text-center phairify-heading-h2 py-5">
            Please make at least one selection on the ‘{{
              conditionQuestion.label
            }}’ question. Click the button below to go to that question now.
          </p>
          <p class="text-center">
            <b-button
              variant="primary"
              @click="$emit('go-to-question', conditionQuestion.id)"
            >
              Go to Question
            </b-button>
          </p>
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'SELECT_ONE'">
          <b-form-radio-group
            class="text-left"
            v-for="v in visibleQuestionVariables"
            :key="v.id"
            :disabled="disabled"
            @change="selectOneRadioChanged(v.id)"
            v-model="preview ? {} : v.response.value"
          >
            <b-form-radio :value="'1'" class="col-12 v3_control_radio">
              {{ v.input_label }}
            </b-form-radio>
          </b-form-radio-group>
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'MULTI_VARIABLE_SELECT_ONE'">
          <multi-variable-select-one
            :variables="visibleQuestionVariables"
            :is-preview="preview"
            @inputChanged="resetDeclinedAndAutosave"
          />
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'SELECT_ANY'">
          <select-any-wrapper
            :variables="visibleQuestionVariables"
            :question="question"
            :preview="preview"
            @select-all-change="onSelectAllHandle"
          >
            <template
              slot-scope="{
                variables,
                isSelectAnyInputDisabled,
                onSelectAnyVarChange,
                isSelectAnyCheckboxDisabledByMaxSelections,
                isSelectAnyCheckBoxDisabledByExclusive,
                disabledByExclusiveTooltipText,
                maximumSelections,
              }"
            >
              <div class="text-left" v-for="v in variables" :key="v.id">
                <span
                  :id="`variable_wrapper_${v.id}`"
                  @click="onShowTooltip(v.id)"
                  @mouseenter="onShowTooltip(v.id)"
                  @mouseleave="visibleSelectAnyTooltipId = null"
                >
                  <b-form-checkbox
                    class="my-2 v3_control_checkbox d-inline-block"
                    :disabled="isSelectAnyInputDisabled(v)"
                    v-model="preview ? {} : v.response.value"
                    :value="'1'"
                    :unchecked-value="null"
                    @input="(val) => onSelectAnyVarChange(val, v)"
                    @change="resetDeclinedAndAutosave"
                  >
                    {{ v.input_label }}
                  </b-form-checkbox>
                </span>
                <b-tooltip
                  v-if="isSelectAnyCheckboxDisabledByMaxSelections(v)"
                  placement="left"
                  :target="`variable_wrapper_${v.id}`"
                >
                  You can only pick a maximum of
                  {{ maximumSelections }} selections.
                </b-tooltip>
                <b-tooltip
                  v-else-if="isSelectAnyCheckBoxDisabledByExclusive(v)"
                  placement="left"
                  :target="`variable_wrapper_${v.id}`"
                  :show="visibleSelectAnyTooltipId === v.id"
                  triggers="click hover"
                >
                  {{ disabledByExclusiveTooltipText }}
                </b-tooltip>
              </div>
            </template>
          </select-any-wrapper>
        </div>

        <!-- --------------------- -->

        <div v-else-if="question.type === 'RATING'">
          <b-row v-for="(v, n) in visibleQuestionVariables" :key="n">
            <b-col>
              <label class="font-weight-bold">{{ v.input_label }}</label>
              <b-form-radio-group
                class="mb-3"
                :disabled="disabled"
                v-model="preview ? {} : v.response.value"
                @change="resetDeclinedAndAutosave()"
              >
                <b-form-radio v-for="i in 3" :key="i" :value="i">
                  {{ i }}
                </b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </div>

        <!-- --------------------- -->

        <study-form-input-slider
          v-else-if="question.type === 'SLIDER'"
          :question="question"
          :variables="questionVariables"
          :visible-variables="visibleQuestionVariables"
          :is-disable-inputs="disabled"
          :is-preview="preview"
          :is-declined="isDeclined"
          :all-variables="variables"
          :all-questions="allQuestions"
          @slider-updated="onSliderUpdated"
          @set-min-updated="onSetMinUpdated"
          @valid-updated="onValidUpdated"
          @slider-set-unknown="onSliderSetUnknown"
        />

        <!-- ------- Decline to answer --------- -->
        <b-row
          v-if="!question.required && question.type !== 'CONFIRMATION'"
          class="text-left decline-wrapper mt-3"
        >
          <b-col cols="12">
            <b-form-checkbox
              :disabled="disabled"
              :checked="preview ? {} : questionVariables[0].response.declined"
              @input="declineChecked"
              :value="1"
              :unchecked-value="0"
              class="my-2"
            >
              Decline to answer
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-3 v2_font_size_12 question-id-wrapper">
            Q{{ question.id }}
          </b-col>
        </b-row>
      </b-col>
    </div>

    <!--  JOB QUESTION PART  -->
    <slot />
  </fragment>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
/*
 * Form for an individual question on the SurveyForm, with autosave of the responses for the question.
 * In order to make this component simpler, responses for each question variable are attached to the variable
 * in SurveyForm::loadSurvey, so we can bind the various input components directly to the response values.
 * When this component is used in question/ModalEditForm, or elsewhere not in the context of a Survey,
 * preview mode must be set in order to prevent errors as a result of the failure of such binding.
 */

import map from 'lodash/map';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import states from '@/providers/States.js';
import regions from '@/providers/Regions.js';
import DerivedVariables from '../providers/DerivedVariables';
import sanitizeHtml from 'sanitize-html';
import {
  compareQuestionVarsByOrder,
  isCompleted,
  isVariableMatchVisibilityCondition,
  replaceCustomTagsWithDataAndHtmlTags,
} from '@/helpers/questionnaireHelper';
import MultiVariableSelectOne from '@/components/question/form/inputs/MultiVariableSelectOne';
import StudyFormInputSlider from '@/components/question/form/inputs/StudyFormInputSlider';
import SelectAnyWrapper from '@/components/study/form/questions/SelectAnyWrapper';

export default {
  name: 'questionForm',
  components: {
    VueBootstrapTypeahead,
    MultiVariableSelectOne,
    StudyFormInputSlider,
    SelectAnyWrapper,
  },
  props: {
    survey: {
      type: Object,
      required: true,
    },
    question: Object,
    variables: Array, // empty in preview mode
    preview: Boolean,
    isLastQuestion: {
      type: Boolean,
      default: true,
    },
    showJobQuestion: {
      type: Boolean,
      default: false,
    },
    allQuestions: Array,
    isSupportJobPreferences: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      visibleSelectAnyTooltipId: null,
      initialSchool:
        this.preview || !this.question.variables[0]
          ? ''
          : this.question.variables[0].response.value,
    };
  },
  created: function () {
    if (!this.preview) {
      this.$nextTick(() => {
        this.$emit('set-is-completed', this.isCompleted());
      });
    }
  },
  computed: {
    questionVariables: function () {
      return [...this.question.variables.sort(compareQuestionVarsByOrder)];
    },
    preamble: function () {
      return sanitizeHtml(
        replaceCustomTagsWithDataAndHtmlTags(
          this.question.preamble,
          this.questionnaire
        )
      );
    },
    prompt: function () {
      return sanitizeHtml(
        replaceCustomTagsWithDataAndHtmlTags(
          this.question.prompt,
          this.questionnaire
        )
      );
    },
    explanation: function () {
      return sanitizeHtml(
        replaceCustomTagsWithDataAndHtmlTags(
          this.question.explanation,
          this.questionnaire
        )
      );
    },
    visibleQuestionVariables: function () {
      return this.questionVariables.filter(
        (variable) =>
          this.preview ||
          (!variable.delete_me &&
            isVariableMatchVisibilityCondition(variable, this.variables))
      );
    },
    conditionQuestion: function () {
      const variableWithCondition = this.questionVariables.find(
        (qV) => qV.condition
      );
      if (!variableWithCondition) return null;
      const intConditionId = parseInt(variableWithCondition.condition);
      const conditionVariable = this.variables.find(
        ({ id }) => intConditionId === parseInt(id)
      );
      if (!conditionVariable) return null;
      return this.allQuestions.find(
        ({ id }) => id === conditionVariable.question_id
      );
    },
    questionnaire: function () {
      return this.survey ? this.survey.questionnaire : null;
    },
    isDeclined: function () {
      if (this.preview) return false;
      return Boolean(this.questionVariables[0].response.declined);
    },
  },
  methods: {
    onShowTooltip: function (id) {
      this.$root.$emit('bv::hide::tooltip');
      this.visibleSelectAnyTooltipId =
        this.visibleSelectAnyTooltipId === id ? null : id;
    },
    getStates: function () {
      return states.states;
    },
    getStateOptions: function () {
      return map(states.states, (name, key) => {
        return { value: key, text: name };
      });
    },
    getRegionOptions: function () {
      return map(regions.regions, (name, key) => {
        return { value: key, text: name };
      });
    },
    getSchoolOptions: function () {
      // TODO: add real school list
      return [
        'Brown',
        'Cornell',
        'Columbia',
        'Dartmouth',
        'Harvard',
        'Penn',
        'Princeton',
        'Yale',
      ];
    },
    getResponseValue: function (variable) {
      if (variable.response) {
        return variable.response.value;
      } else {
        return {};
      }
    },
    formatDerivedVariableResponseValue: function (v) {
      if (v.response && v.response.value && v.dv_name) {
        const dv = DerivedVariables.calculationVariables[v.dv_name];
        const prefix = dv.prefix;
        const num = parseFloat(v.response.value).toLocaleString('en', {
          currency: 'USD',
          maximumFractionDigits: 0,
        });
        return prefix + num;
      } else {
        return '';
      }
    },
    onSliderUpdated: function ({ uid, val }) {
      if (!this.preview) {
        const varIndex = this.visibleQuestionVariables.findIndex(
          (v) => v.id === uid
        );
        if (varIndex === -1) return;
        const variable = this.visibleQuestionVariables[varIndex];
        this.$set(variable.response, 'value', val);
        if (val > variable.min && variable.response.is_set_min) {
          this.$set(variable.response, 'is_set_min', 0);
        }
        if (val !== null && val !== undefined) {
          this.resetDeclinedAndAutosave();
        }
      }
    },
    onSliderSetUnknown: function (val) {
      this.questionVariables.forEach((v) => {
        this.$set(v.response, 'is_unknown', val);
        this.$set(v.response, 'is_set_min', 0);
      });
      this.resetDeclinedAndAutosave();
    },
    onSetMinUpdated: function ({ uid, val }) {
      if (!this.preview) {
        const varIndex = this.visibleQuestionVariables.findIndex(
          (v) => v.id === uid
        );
        if (varIndex === -1) return;
        this.$set(
          this.visibleQuestionVariables[varIndex].response,
          'is_set_min',
          val
        );
        if (!val) {
          this.$set(
            this.visibleQuestionVariables[varIndex].response,
            'value',
            null
          );
        }
        if (val !== null && val !== undefined) {
          this.resetDeclinedAndAutosave();
        }
      }
    },
    selectOneRadioChanged: function (checkedId) {
      // When a radio for a SELECT_ONE question is selected, set the values for the other vars to null
      // (This is different than the YES_NO case, where both radios are backed by a single
      // boolean variable. In this case each radio has a boolean variable, and we have to work around
      // the normal way of binding values to radios. Each radio is essentially behaving like a checkbox,
      // but we only allow one to be selected.)
      // HACK: we must also use a string value for the radio binding to work (otherwise the radio
      // will unselect itself after a second - ???)
      this.questionVariables.forEach((v) => {
        v.response.value = v.id === checkedId ? '1' : 0;
      });
      this.resetDeclinedAndAutosave();
    },
    resetDeclinedAndAutosave: function () {
      if (!this.preview) {
        this.$set(this.questionVariables[0].response, 'declined', 0);
        this.$emit('question-form-change');
      }
    },
    declineChecked: function (declined) {
      if (!this.preview) {
        this.questionVariables[0].response.declined = declined;
        if (declined) {
          this.questionVariables.forEach((_, index) => {
            this.$set(this.questionVariables[index].response, 'value', null);
            this.$set(this.questionVariables[index].response, 'is_unknown', 0);
            this.$set(this.questionVariables[index].response, 'invalid', 0);
            this.$set(this.questionVariables[index].response, 'is_set_min', 0);
          });
        }
        this.$emit('question-form-change');
      }
    },
    getQuestionVariables: function () {
      return this.questionVariables;
    },
    isCompleted: function () {
      return isCompleted(
        {
          ...this.question,
          variables: this.questionVariables,
        },
        this.isSupportJobPreferences
      );
    },
    onValidUpdated: function (newVal) {
      this.questionVariables[0].response.invalid = !newVal;
      this.$emit('question-form-change');
    },
    onSelectAllHandle: function (isAllSelected) {
      if (this.preview) return;
      this.visibleQuestionVariables.forEach((variable, index) => {
        if (variable.is_exclusive) return;
        this.$set(
          this.visibleQuestionVariables[index].response,
          'value',
          isAllSelected ? 1 : 0
        );
      });
      this.declineChecked(0);
      this.$emit('question-form-change');
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->
<style>
.custom-checkbox .custom-control-label::before{
  border: 2px solid #9BA1A5;
  border-radius: 4px !important;
}
</style>
<style scoped>
@media (min-width: 320px) and (max-width: 768px){
.v2_study_question_section{
padding: 40px 10px 60px;
}
}
</style>
<style lang="scss" scoped>
// include this in any Vue component where you want to reference vars or mixins
@import '../../sass/variables_mixins.scss';

.question-form {
  border-radius: 4px;

  > .row {
    //align-items: center;
  }

  div.border-bottom {
    border-bottom-color: $phairify_primary_border_color !important;
  }
}

.question-form__question {
  font-size: 1.25em;
  color: $phairify_dark_sky_blue;
  background-color: rgba($phairify_primary_color_teal, 0.1);
  @media (max-width: $tablet-portrait - 1px) {
    padding: 2em 1em;
  }
  @media (min-width: $tablet-portrait) {
    padding: 2em;
  }
}

.question-form__answer {
  padding-top: 1em;
  //border:solid 1px #ccc;
  background-color: #fff;
  @media (max-width: $tablet-portrait - 1px) {
    //border-top: none;
    //border-radius: 0 0 5px 5px;
  }
  @media (min-width: $tablet-portrait) {
    //border-left:none;
    //border-radius:0 5px 5px 0;
  }

  .custom-checkbox {
    margin-left: 1em;
  }

  .question-form__slider-wrapper {
    height: calc(100% - 100px);
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.required-question {
      height: 100%;
      padding-bottom: 1.5rem;
    }
  }

  .set-my-preferences-button-wrapper + .question-form__slider-wrapper {
    height: calc(100% - 140px);
  }
}

.explanation {
  font-family: 'Questrial', sans-serif;
  border-radius: 5px;
  font-style: italic;
}

.decline-wrapper {
  border-top: solid 1px $phairify_primary_border_color;
  padding-top: 10px;
  margin-top: 35px;
}

.question-id-wrapper {
  position: absolute;
  bottom: 20px;
  color: lightgrey;
}
</style>
